import { selectCurrentUser } from "../global";

import { selectUsersWithRole } from "./user";

import { RootState } from "shared/types";
import { RoleType } from "shared/types/user";
import { stringComparatorGenerator } from "utils/string";

export const selectIsCaptioned = () => (state: RootState) =>
  Object.values(state.classroom.client.users).filter((user) => user.role === RoleType.Captioner)
    .length > 0;

export const selectCaptionerIsPresent = () => (state: RootState) =>
  selectUsersWithRole(RoleType.Captioner)(state).some((user) => user.is_present);

export const selectLatestCaption = () => (state: RootState) =>
  state.classroom.client.latest_caption;

export const selectCurrentUserIsCaptionsLeader = () => (state: RootState) => {
  const currentUser = selectCurrentUser()(state);
  const captioners = selectUsersWithRole(RoleType.Captioner)(state);
  const presentCaptioners = captioners.filter((user) => user.is_present);
  presentCaptioners.sort(stringComparatorGenerator((user) => user.id));
  return currentUser.id === presentCaptioners[0]?.id;
};

export const selectShowLiveCaptions = () => (state: RootState) => {
  const isCaptioned = selectIsCaptioned()(state);
  const currentUser = selectCurrentUser()(state);
  const { enable_live_captions, is_recording_agent } = currentUser || {};
  return isCaptioned && (enable_live_captions || is_recording_agent);
};
